import React from "react";
import { useTranslation } from "react-i18next";
import { TOptions, StringMap } from "i18next";

export type useTKeyFn = (key: string, options?: TOptions<StringMap>) => string;

const useTKey = (prefix: string): useTKeyFn => {
  const [t] = useTranslation();
  return React.useCallback(
    (key: string, options?: TOptions<StringMap>) => t(`${prefix}.${key}`, { ...options }),
    [prefix, t]
  );
};

export default useTKey;
